module.exports = __webpack_public_path__ + "static/media/category.fa3b754b.svg";